import "heroicons-wc/hi-outline-credit-card.js";
import "heroicons-wc/hi-outline-banknotes.js";
import "heroicons-wc/hi-outline-arrow-down-on-square.js";
import "heroicons-wc/hi-outline-building-library.js";
import "heroicons-wc/hi-outline-arrow-up-on-square.js";
import "heroicons-wc/hi-outline-currency-euro.js";
import "heroicons-wc/hi-solid-credit-card.js";
import "heroicons-wc/hi-solid-banknotes.js";
import "heroicons-wc/hi-solid-arrow-down-on-square.js";
import "heroicons-wc/hi-solid-building-library.js";
import "heroicons-wc/hi-solid-arrow-up-on-square.js";
import "heroicons-wc/hi-solid-currency-euro.js";
import "heroicons-wc/hi-mini-credit-card.js";
import "heroicons-wc/hi-mini-banknotes.js";
import "heroicons-wc/hi-mini-arrow-down-on-square.js";
import "heroicons-wc/hi-mini-building-library.js";
import "heroicons-wc/hi-mini-arrow-up-on-square.js";
import "heroicons-wc/hi-mini-currency-euro.js";
import "heroicons-wc/hi-micro-credit-card.js";
import "heroicons-wc/hi-micro-banknotes.js";
import "heroicons-wc/hi-micro-arrow-down-on-square.js";
import "heroicons-wc/hi-micro-building-library.js";
import "heroicons-wc/hi-micro-arrow-up-on-square.js";
import "heroicons-wc/hi-micro-currency-euro.js";

import { choose } from "lit/directives/choose.js";
import { html, unsafeStatic } from "lit/static-html.js";
import { assert } from "#core/utils/assert.ts";

export const paymentMethodIcon = (
  mode: string,
  size: "outline" | "solid" | "mini" | "micro",
) => {
  assert(["outline", "solid", "mini", "micro"].includes(size));

  return choose(
    mode,
    [
      [
        "bank-card",
        () =>
          html`<hi-${unsafeStatic(size)}-credit-card></hi-${unsafeStatic(size)}-credit-card>`,
      ],
      [
        "cash",
        () =>
          html`<hi-${unsafeStatic(size)}-banknotes></hi-${unsafeStatic(size)}-banknotes>`,
      ],
      [
        "bank-transfer",
        () =>
          html`<hi-${unsafeStatic(size)}-arrow-down-on-square></hi-${unsafeStatic(size)}-arrow-down-on-square>`,
      ],
      [
        "cheque",
        () =>
          html`<hi-${unsafeStatic(size)}-building-library></hi-${unsafeStatic(size)}-building-library>`,
      ],
      [
        "direct-debit",
        () =>
          html`<hi-${unsafeStatic(size)}-arrow-up-on-square></hi-${unsafeStatic(size)}-arrow-up-on-square>`,
      ],
    ],
    () =>
      html`<hi-${unsafeStatic(size)}-currency-euro></hi-${unsafeStatic(size)}-currency-euro>`,
  );
};

export const paymentMethodToLocaleString = (locales: "fr-FR", mode: string) => {
  if (locales !== "fr-FR") {
    throw new Error(`unsupported locale: ${locales}`);
  }

  switch (mode) {
    case "bank-card":
      return "Carte Bancaire";
    case "cash":
      return "Monnaie";
    case "bank-transfer":
      return "Virement Bancaire";
    case "cheque":
      return "Chèque";
    case "direct-debit":
      return "Prélèvement Bancaire";
  }

  throw new Error(`unknown payment mode: ${mode}`);
};
